export default __webpack_public_path__ + "static/media/KPI.68361b29.png";